/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_ToolsInputs */

const en_quick_tools = /** @type {(inputs: Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QuickTools`)
};

const fr_quick_tools = /** @type {(inputs: Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils rapides`)
};

const de_quick_tools = /** @type {(inputs: Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QuickTools`)
};

const it_quick_tools = /** @type {(inputs: Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti rapidi`)
};

const ru_quick_tools = /** @type {(inputs: Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстрые инструменты`)
};

const es_quick_tools = /** @type {(inputs: Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas rápidas`)
};

const zh_cn2_quick_tools = /** @type {(inputs: Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速工具`)
};

const ja_quick_tools = /** @type {(inputs: Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイックツール`)
};

const hi_quick_tools = /** @type {(inputs: Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्विकटूल्स`)
};

const pt_pt2_quick_tools = /** @type {(inputs: Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas Rápidas`)
};

/**
* | output |
* | --- |
* | "QuickTools" |
*
* @param {Quick_ToolsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quick_tools = /** @type {((inputs?: Quick_ToolsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_ToolsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quick_tools(inputs)
	if (locale === "de") return de_quick_tools(inputs)
	if (locale === "it") return it_quick_tools(inputs)
	if (locale === "ru") return ru_quick_tools(inputs)
	if (locale === "es") return es_quick_tools(inputs)
	if (locale === "zh-CN") return zh_cn2_quick_tools(inputs)
	if (locale === "ja") return ja_quick_tools(inputs)
	if (locale === "hi") return hi_quick_tools(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_tools(inputs)
	return en_quick_tools(inputs)
});